import React from 'react';
import { useNavigate } from 'react-router-dom';
import OpenPlayToolsLayout from '../../components/openplay/OpenPlayToolsLayout';
import Icon from '../../components/openplay/OpenPlayIcon';
import { COMMUNITY_BOARDS } from './communityConfig';

const COMMUNITY_ITEMS = [
  {
    id: 'matching',
    title: COMMUNITY_BOARDS.matching.label,
    description: COMMUNITY_BOARDS.matching.description,
    icon: 'UserGroupIcon',
  },
  {
    id: 'free',
    title: COMMUNITY_BOARDS.free.label,
    description: COMMUNITY_BOARDS.free.description,
    icon: 'ChatBubbleLeftRightIcon',
  },
];

const OpenPlayCommunityMenuPage = () => {
  const navigate = useNavigate();

  return (
    <OpenPlayToolsLayout userRole="player">
      <main className="pt-6 md:pt-10 pb-[calc(84px+env(safe-area-inset-bottom,16px))] md:pb-10">
        <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="mb-6 md:mb-8">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-2">커뮤니티</h1>
            <p className="text-base md:text-lg caption text-muted-foreground">우리 동네 피클 볼러와 자유게시판을 운영할 수 있습니다.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {COMMUNITY_ITEMS.map((item) => (
              <button
                key={item.id}
                type="button"
                className="bg-card border border-border rounded-xl hover-lift transition-athletic p-5 md:p-6 flex flex-col items-start text-left"
                onClick={() => navigate(`/openplay/community/${item.id}`)}
              >
                <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Icon name={item.icon} size={30} className="text-primary" />
                </div>
                <div className="mt-4">
                  <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">{item.title}</h2>
                  <p className="text-sm caption text-muted-foreground mt-2 leading-relaxed">{item.description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </main>
    </OpenPlayToolsLayout>
  );
};

export default OpenPlayCommunityMenuPage;
